<template>
  <div>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="12" class="my-1">
        <b-form-group label-cols="2" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"/>
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table
      show-empty
      empty-text="There are no draft formative evaluations at this time."
      striped
      responsive
      stacked="md"
      :items="items"
      :fields="fields"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
    >
      <template v-slot:cell(period)="row">
        {{ row.item.period }}
        <div v-if="row.item.draft == true" class="text-success">DRAFT</div>
      </template>
      <template slot="HEAD_user" slot-scope="data">
        <div v-if="role !== 'student'">Student</div>
        <div v-else>Instructor</div>
      </template>
      <template v-slot:cell(user)="row">
        <div v-if="role !== 'student'">{{ row.item.user.name }}</div>
        <div v-else>{{ row.item.instructor_name }}</div>
      </template>
      <template v-slot:cell(created_at)="row">
          {{ moment(row.item.created_at).format('MMM DD YYYY') }}
        </template>
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button-group>
          <b-button v-if="role == 'school'" @click="editEvaluation(row.item.id)" class="btn btn-warning">
            <span class="icon icon-pencil"> Edit</span>
          </b-button>
          <b-button v-if="role == 'school'" @click="deleteEvaluation(row.item.id)" class="btn btn-danger">
            <span class="icon icon-trash"> Delete</span>
          </b-button>
        </b-button-group>
      </template>
    </b-table>

  </div>
</template>

<script>
const items = [];
var moment = require("moment");
export default {
  props: ["evaluations", "surl", "user_role"],
  data() {
    return {
      moment: moment,
      items: this.evaluations,
      url: this.surl,
      role: this.user_role,
      fields: [
        {
          key: "period",
          label: "Period"
        },
        {
          key: "user",
          label: "Instructor"
        },
        {
          key: "created_at",
          label: "Saved"
        },
        {
          key: "total_score",
          label: "Score"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ],
      filter: null,
      sortBy: "created_at",
      sortDesc: true
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  filters: {
    uppercase: function(v) {
      return v.toUpperCase();
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewEvaluation(id) {
      window.location.href = this.surl + id;
    },
    editEvaluation(id) {
      window.location.href = "/instructor/formative-evaluation/edit/" + id;
    },
    deleteEvaluation(id) {
      Swal.fire({
                title: 'Delete this Draft?',
                text: "This cannot be undone!",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok'
            }).then((result) => {
            if (result.isConfirmed) {
                axios.get('/instructor/formative-evaluation/delete/' + id)
                .then(response => this.items = response.data)
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });
            }
        });
    }
  }
};
</script>

<!-- table-complete-1.vue -->